import { render } from "./salesCreate.vue?vue&type=template&id=0b947c17&scoped=true"
import script from "./salesCreate.vue?vue&type=script&lang=js"
export * from "./salesCreate.vue?vue&type=script&lang=js"

import "./salesCreate.vue?vue&type=style&index=0&id=0b947c17&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b947c17"]])

export default __exports__